import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analytics';

/**
 * Custom hook to automatically track page views when routes change
 * Should be used in the main layout component
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    const currentPath = location.pathname + location.search;
    trackPageView(currentPath);
  }, [location]);
};
